<template>
  <div class="col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2">
    <div id="environment-ribbon" :class="'banner-' + getEnvironment()">
      {{ getEnvironmentText() }}
    </div>
    <form method="#" action="#">
      <div class="card" data-background="color" data-color="blue">
        <div class="card-header">
          <h3 class="card-title pull-left">Account Management Login</h3>
        </div>
        <br><br>
        <div class="card-content">
          <div class="form-group">
            <label>Management Username</label>
            <input type="text" placeholder="Username"
            name="userId"
            v-validate="modelValidations.userId"
            v-model="model.userId"
            class="form-control input-no-border">
            <small class="text-danger" v-show="userId.invalid">
                {{ getError('userId') }}
            </small>
          </div>
          <div class="form-group">
            <label>Password</label>
            <input type="password" placeholder="Password"
            name="password"
            v-validate="modelValidations.password"
            v-model="model.password"
            class="form-control input-no-border">
            <small class="text-danger" v-show="password.invalid">
                {{ getError('password') }}
            </small>
          </div>
        </div>
        <div class="card-footer text-center">
          <button :disabled="loading" @click.prevent="validate" type="submit" class="btn btn-fill btn-wd"><i class="ti-lock"></i> Sign In</button>
          <br>
          <span v-if="loading"><i class="fa fa-spinner fa-pulse"></i> Signing in...</span>
          <br>
          <transition name="fade" mode="out-in"><p class="alert alert-danger" v-if="serverError">{{ serverError }}</p></transition>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate'

export default {
  computed: {
    ...mapFields(['userId', 'password'])
  },
  data () {
    return {
      serverError: false,
      loading: false,
      model: {
        userId: '',
        password: ''
      },
      modelValidations: {
        userId: {
          required: true,
          alpha_num: true
        },
        password: {
          required: true
        }
      }
    }
  },
  methods: {
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.serverError = false
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.$emit('on-submit', this.model)
          this.$http.post('/manager/login', this.model)
            .then(response => {
              if (!response.data.authenticated) {
                throw response.data.error
              }
              this.$store.state.managerData = response.data.user
              this.$gtag.set('user_properties',
                {
                  user_id: 'm' + response.data.user.ID,
                  group_name: response.data.user.groups[0].GroupName
                })
              if (this.$store.state.managerData.GroupId !== 0) {
                this.$router.push({ path: '/management/trustoverview' })
              } else {
                this.$router.push({ path: '/management/accountview' })
              }
            })
            .catch(error => {
              this.serverError = error
            })
        }
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home/Forms/ManagementLogin.vue